//  EXAM ACTION TYPES
export const FETCH_EXAM_START = 'FETCH_EXAM_START';
export const FETCH_EXAM_SUCCESS = 'FETCH_EXAM_SUCCESS';
export const FETCH_EXAM_FAIL = 'FETCH_EXAM_FAIL';
export const FETCH_EXAMS_SUCCESS = 'FETCH_EXAMS_SUCCESS';
export const SET_OPEN_EXAM_MODAL = 'SET_OPEN_EXAM_MODAL';
export const SET_OPEN_RESULT_MODAL = 'SET_OPEN_RESULT_MODAL';
export const SET_QUESTION_EXAM_NUMBER = 'SET_QUESTION_EXAM_NUMBER';
export const SET_EXAM_QUESTIONS = 'SET_EXAM_QUESTIONS';
export const SET_EXAM_DATA = 'SET_EXAM_DATA';
export const CLEAR_EXAM_STATE = 'CLEAR_EXAM_STATE';
export const SET_STARTED_EXAM = 'SET_STARTED_EXAM';
export const SET_EXAM_ANSWERS = 'SET_EXAM_ANSWERS';
export const SET_STREAK_UPDATED = 'SET_STREAK_UPDATED';
export const SET_START_TIME = 'SET_START_TIME';
export const FETCH_EXAM_LOGS_SUCCESS = 'FETCH_EXAM_LOGS_SUCCESS';
export const SET_STREAK = 'SET_STREAK';
export const SET_ACTIVE_EXAM = 'SET_ACTIVE_EXAM';
export const SET_GENERATE_FILTERS = 'SET_GENERATE_FILTERS';
export const CLEAR_GENERATE_FILTERS = 'CLEAR_GENERATE_FILTERS';

//  RANKING ACTION TYPES
export const FETCH_RANKING_START = 'FETCH_RANKING_START';
export const FETCH_RANKING_SUCCESS = 'FETCH_RANKING_SUCCESS';
export const FETCH_RANKING_FAIL = 'FETCH_RANKING_FAIL';
export const SELECT_RANKING = 'SELECT_RANKING';

//  DASHBOARD STATS ACTION TYPES
export const FETCH_DASHBOARD_STATS_START = 'FETCH_DASHBOARD_STATS_START';
export const FETCH_DASHBOARD_STATS_SUCCESS = 'FETCH_DASHBOARD_STATS_SUCCESS';
export const FETCH_DASHBOARD_STATS_FAIL = 'FETCH_DASHBOARD_STATS_FAIL';
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';

// FILTERING
export const SET_FILTER_INITIAL_STATE = 'SET_FILTER_INITIAL_STATE';
export const SET_FILTER_QUESTION_DIFFICULTY = 'SET_FILTER_QUESTION_DIFFICULTY';
export const SET_FILTER_QUESTION_SUBJECT = 'SET_FILTER_QUESTION_SUBJECT';
export const SET_FILTER_QUESTION_CHAPTER = 'SET_FILTER_QUESTION_CHAPTER';
export const SET_FILTER_QUESTION_ID = 'SET_FILTER_QUESTION_ID';
export const SET_FILTER_QUESTION_SOURCE = 'SET_FILTER_QUESTION_SOURCE';
export const SET_FILTER_QUESTION_TYPE = 'SET_FILTER_QUESTION_TYPE';

// QUESTIONS ACTION TYPES
export const FETCH_QUESTION_SUCCESS = 'FETCH_QUESTION_SUCCESS';
export const FETCH_INTERACTIVE_QUESTION_START = 'FETCH_INTERACTIVE_QUESTION_START';
export const FETCH_INTERACTIVE_QUESTION_SUCCESS = 'FETCH_INTERACTIVE_QUESTION_SUCCESS';
export const FETCH_INTERACTIVE_QUESTION_FAIL = 'FETCH_INTERACTIVE_QUESTION_FAIL';
export const UPDATE_QUESTION_START = 'UPDATE_QUESTION_START';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAIL = 'UPDATE_QUESTION_FAIL';
export const SET_HISTORY_INTERACTIVE = 'SET_HISTORY_INTERACTIVE';
export const RESET_HISTORY_INTERACTIVE = 'RESET_HISTORY_INTERACTIVE';
export const SET_QUESTION_LOG = 'SET_QUESTION_LOG';

//  PAGINATION ACTION TYPES
export const RESET_PAGINATION = 'RESET_PAGINATION';
export const SET_PAGINATION_PAGE = 'SET_PAGINATION_PAGE';
export const SET_PAGINATION_PAGE_SIZE = 'SET_PAGINATION_PAGE_SIZE';
export const SET_PAGINATION_QUERY_PARAMS = 'SET_PAGINATION_QUERY_PARAMS';
export const SET_PAGINATION_TOTAL_COUNT = 'SET_PAGINATION_TOTAL_COUNT';
export const SET_PAGINATION_CHANGE_EVENT = 'SET_PAGINATION_CHANGE_EVENT';

// THEME ACTION TYPES
export const TOGGLE_DARKMODE = 'TOGGLE_DARKMODE';

// USER ACTION TYPES
export const LOGIN_USER_START = 'LOGIN_USER_START';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAIL = 'LOGIN_USER_FAIL';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const SET_PLATFORM_REPORT = 'SET_PLATFORM_REPORT';
export const SET_OPEN_STREAK_MODAL = 'SET_OPEN_STREAK_MODAL';

// PROFILE ACTION TYPES
export const UPDATE_USER_PROFILE_ERROR = 'UPDATE_USER_PROFILE_ERROR';
export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';
export const UPDATE_USER_START = 'FETCH_USER_START';
export const UPDATE_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'FETCH_USER_FAIL';
export const UPDATE_USER_STREAK = 'UPDATE_USER_STREAK';

// PLATFORM REPORTS ACTION TYPES
export const FETCH_PLATFORM_REPORTS_START = 'FETCH_PLATFORM_REPORTS_START';
export const FETCH_PLATFORM_REPORTS_SUCCESS = 'FETCH_PLATFORM_REPORTS_SUCCESS';
export const FETCH_PLATFORM_REPORTS_FAIL = 'FETCH_PLATFORM_REPORTS_FAIL';
export const SET_OPEN_PLATFORM_REPORT_MODAL = 'SET_OPEN_PLATFORM_REPORT_MODAL';

// STRIPE ACTION TYPES
export const FETCH_PRODUCTS_START = 'FETCH_PRODUCTS_START';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL';

export const FETCH_CHARGES_START = 'FETCH_CHARGES_START';
export const FETCH_CHARGES_SUCCESS = 'FETCH_CHARGES_SUCCESS';
export const FETCH_CHARGES_FAIL = 'FETCH_CHARGES_FAIL';

export const FETCH_ACTIVE_SUBSCRIPTION_START = 'FETCH_ACTIVE_SUBSCRIPTION_START';
export const FETCH_ACTIVE_SUBSCRIPTION_SUCCESS = 'FETCH_ACTIVE_SUBSCRIPTION_SUCCESS';
export const FETCH_ACTIVE_SUBSCRIPTION_FAIL = 'FETCH_ACTIVE_SUBSCRIPTION_FAIL';
